module.exports = __webpack_public_path__ + "files/edbd3553372278b3322be9876bb67015.png";